module.exports = __webpack_public_path__ + "static/media/9.ba859a0a.jpg";